export default "__VITE_ASSET__zyS_P6vh__"